import moment from "moment";

import { prepareParam } from "../helpers/utils";
import instance from "./instance";
import mockData from "./mock.json";
import axios from "axios";

export const mock = false;

export const login = async (data) => {
  switch (mock) {
    case true:
      return { status: 200, data: mockData.login };
    default:
      return instance.post("/Login/Token", data);
  }
};
export const loginWithOtp = async (data) => {
  switch (mock) {
    case true:
      return { status: 200, data: mockData.login };
    default:
      return instance.post("/Login/LoginWithOtp", data);
  }
};
export const completeLoginWithOtp = async (data) => {
  switch (mock) {
    case true:
      return { status: 200, data: mockData.login };
    default:
      return instance.post("/Login/CompleteLoginWithOtp", data);
  }
};

export const sendChangePasswordOTP = async () => {
  switch (mock) {
    case true:
      return { status: 200, data: 123456 };
    default:
      return instance.get("/Login/SendChangePasswordOTP");
  }
};

export const sendUpdateProfileOTP = async () => {
  switch (mock) {
    case true:
      return { status: 200, data: 123456 };
    default:
      return instance.get("/Login/SendUpdateProfileOTP");
  }
};

export const getMyProfile = async () => {
  switch (mock) {
    case true:
      return { status: 200, data: mockData.getMyProfile };
    default:
      return instance.get("/Login/GetMyProfile");
  }
};

export const changeMyPassword = async (data) => {
  switch (mock) {
    case true:
      return { status: 200, data: {} };
    default:
      return instance.post("/Login/ChangeMyPassword", data);
  }
};

export const updateMyProfile = async (data) => {
  switch (mock) {
    case true:
      return { status: 200, data: {} };
    default:
      return instance.put("/Login/UpdateMyProfile", data);
  }
};

export const sendForgetPasswordOTP = async (data) => {
  switch (mock) {
    case true:
      return { status: 200, data: {} };
    default:
      return instance.post("/Login/SendForgetPasswordOTP", data);
  }
};

export const resetPassword = async (data) => {
  switch (mock) {
    case true:
      return { status: 200, data: {} };
    default:
      return instance.post("/Login/ResetPassword", data);
  }
};

export const refreshToken = async (data) => {
  switch (mock) {
    case true:
      return { status: 200, data: mockData.login };
    default:
      return instance.post("/Login/RefreshToken", data);
  }
};

export const checkSelleingClearance = async (pRandom, value, nationalIds) => {
  const isByPass = process.env.REACT_APP_CLEARANCE_BYPASS !== "NULL";

  switch (
  mock ||
  (isByPass && value === process.env.REACT_APP_CLEARANCE_BYPASS)
  ) {
    case true:
      return { status: 200, data: mockData.GetClearanceDetails };
    default:
      return instance.get(
        `/Clearance/GetClearanceDetails?PRandom=${pRandom}&Barcode=${value}&SellerNationalIDs=${nationalIds}`,
      );
  }
};

export const getLandInsurance = async (RegNo) => {
  return instance.get(`/Land/GetLandInsurance?RegNo=${prepareParam(RegNo)}`);
};

export const getAgileGisOrganization = async (dlskey) => {
  switch (mock) {
    case true:
      return { status: 200, data: "" };
    default:
      return instance.get(`/Land/GetAGILE_GIS_ORGANIZATION?dlskey=${dlskey}`, {
        hideToaster: true,
      });
  }
};

export const getMyProperties = async () => {
  switch (mock) {
    case true:
      return { status: 200, data: mockData.getMyProperty };
    default:
      return instance.get("/Land/GetMyProperties");
  }
};

export const getPropartyOwners = async (pRandom = 0, dlskey = 0, RegNo = 0) => {
  if (mock) {
    return { status: 200, data: mockData.getProperyOwners2 };
  } else {
    if (pRandom) {
      return instance.get(`/Land/GetOwnersBy?pRandom=${pRandom}`);
    } else if (dlskey) {
      return instance.get(`/Land/GetOwnersBy?DlsKey=${dlskey}`);
    } else if (RegNo) {
      return instance.get(`/Land/GetOwnersBy?RegNo=${prepareParam(RegNo)}`);
    }
  }
};
export const getOwnersOnly = async (
  dlskey,
  PRCLTYPE,
  BuildNo,
  StareNo,
  FlatNo,
) => {
  if (mock) {
    return { status: 200, data: mockData.getProperyOwners };
  } else {
    let params = "";
    if (PRCLTYPE) {
      params += `&PRCLTYPE=${PRCLTYPE}`;
    }
    if (BuildNo) {
      params += `&BuildNo=${BuildNo}`;
    }
    if (StareNo) {
      params += `&StareNo=${StareNo}`;
    }
    if (FlatNo) {
      params += `&FlatNo=${FlatNo}`;
    }
    return instance.get(`/Land/GetOwnersOnly?DLSKey=${dlskey}${params}`);
  }
};
export const getOwnersByLandRegNo = async (RegNo) => {
  if (mock) {
    return { status: 200, data: mockData.getProperyOwners };
  } else {
    return instance.get(
      `/Land/GetOwnersByLandRegNo?landRegNo=${prepareParam(RegNo)}`,
    );
  }
};

export const getPropertyById = async ({ pRandom, DlsKey, reG_NO }) => {
  switch (mock) {
    case true:
      return {
        status: 200,
        data: {
          ...mockData.getLandBy3,
          reG_NO: Date.now().toString() + Math.floor(Math.random() * 1000).toString()
        }
      };
    default: {
      if (reG_NO) {
        return instance.get(`/Land/GetLandBy?regNo=${prepareParam(reG_NO)}`);
      }
      if (pRandom) {
        return instance.get(`/Land/GetLandBy?PRandom=${pRandom}`);
      }
      return DlsKey && instance.get(`/Land/GetLandBy?DlsKey=${DlsKey}`);
    }
  }
};

export const getLandByV2 = async ({
  pRandom,
  DlsKey,
  PRCLTYPE,
  BuildNo,
  StareNo,
  FlatNo,
}) => {
  switch (mock) {
    case true:
      return { status: 200, data: mockData.getLandBy };
    default:
      return pRandom
        ? instance.get(`/Land/GetLandByV2?PRandom=${pRandom}`)
        : DlsKey &&
        instance.get(`/Land/GetLandByV2`, {
          params: {
            DlsKey,
            PRCLTYPE,
            BuildNo,
            StareNo,
            FlatNo,
          },
        });
  }
};

export const getTotDinarForRefund = async (refrenceNumber) => {
  switch (mock || process.env.REACT_APP_REFRANCE_NUM === refrenceNumber) {
    case true:
      return { status: 200, data: 500 };
    default:
      return instance.get(`/Refund/GetTotDinarForRefund`, {
        params: { refrenceNumber },
      });
  }
};
export const getAgileRecomendedOrder = async (refrenceNumber) => {
  switch (mock) {
    case true:
      return {
        status: 200,
        data: {
          e_DOC_NO: "20247DLS10018707945206",
          ordeR_NO: "1234",
          ordeR_YEAR: 2024,
          ordeR_DATE: "2024-09-13T00:00:00",
          reC_NO: "4321",
          reC_DATE: "2024-09-05T00:00:00",
        },
      };
    default:
      return instance.get(
        `/Land/GetAgileRecomendedOrder?E_DOC_NO=${refrenceNumber}`,
      );
  }
};
export const getOldOrderDataByOrderNumber = async (
  orderNumber,
  isBuyerNationalIds = false,
) => {
  switch (mock || process.env.REACT_APP_REFRANCE_NUM === orderNumber) {
    case true:
      return {
        status: 200,
        data: {
          currentProcessInstance: {},
          lstVariables: {
            object: `{"refrenceNumber": "${process.env.REACT_APP_REFRANCE_NUM === orderNumber
              ? process.env.REACT_APP_REFRANCE_NUM
              : 0
              }", "propertyData":{"zoneCode":"1","zoneDesc":"اقليم الوسط","distrecT_CODE":"1","distrecT_ANAME":"محافظة العاصمة","depT_CODE":"4","depT_ANAME":"اراضي شمال عمان","vilL_CODE":"118","vilL_ANAME":"بدران","hoD_CODE":"6","hoD_ANAME":"ذهيبه","secT_CODE":"0","secT_ANAME":"جدول الأحياء","reG_NO":"REGNO00015512AN","dlS_KEY":"011800600001339","parC_NO":"1339","sheeT_NO":"19","prcL_AREA":131,"flat":"000","builD_NO":0,"starE_NO":0,"flaT_NO":0,"prcL_TYPE":"6","lanD_TYPE_DESC":"ملك خارج حدود البلديات/بئرماء","landFlag":"LAND","flatDlsKey":"011800600001339","regStatus":true,"regStatusDesc":"فعالة","owN_SHARES":1,"sharE_NO":3,"docCode":"10","docAname":"بيع عادي","owN_DATE":"2010-11-28T00:00:00","partY_CODE":"1","partY_ID":"9771038535","partY_NAME":"محمود يوسف موسى ادعيس","perName":"محمود","perFather":"يوسف","perGrand":"موسى","perFamily":"ادعيس","partyName1":"ملك خاص","counT_CODE":"11","countAname":"الأردن","nationality":"الأردنية","ownStatus":true,"owshAppUser":"SAL2AN-9183","owshAppDate":"2010-11-28T09:46:35","owshUpdateUser":"SAL2AN-9183","owshUpdateDate":"2010-11-28T09:47:00","prclAppUser":"IND14AN","prclAppDate":"2010-10-04T13:31:24","prclUpdateUser":"DLS9264","prclUpdateDate":"2018-09-18T14:12:55","pRandom":"21180-3WBH42","vouRcptDate":"2020-12-17T00:00:00","landAnnotationModel":[]}}`,
          },
          reG_NO: "REGNO00015512AN",
        },
      };

    default:
      return instance.post(
        `/api/Camunda/GetProcessInstanceAllVariablesByFilteredParameters?isBuyerNationalIds=${isBuyerNationalIds}`,
        {
          refrenceNumber: orderNumber,
        },
      );
    // return instance.post(
    //   `/api/Camunda/GetProcessInstanceAllVariablesByFilteredParametersCompletedAndNotRefused`,
    //   {
    //     refrenceNumber: orderNumber,
    //   }
    // );
  }
};

export const getMortgageContractByNo = async ({ pRandom }) => {
  switch (mock) {
    case true:
      return { status: 200, data: mockData.mortgageContract };
    default:
      return instance.get(`/Land/GetLandBy?PRandom=${pRandom}`);
  }
};

export const getFinanceLeaseContractByNo = async ({ pRandom }) => {
  switch (mock) {
    case true:
      return { status: 200, data: mockData.financeLeaseContract };
    default:
      return instance.get(`/Land/GetLandBy?PRandom=${pRandom}`);
  }
};

export const getUserContacts = async () => {
  switch (mock) {
    case true:
      return { status: 200, data: mockData.GetContactInformation };
    default:
      return instance.get(`/Info/GetContactInformation`);
  }
};

export const checkPersonTaxClearance = async (NationalID) => {
  switch (mock) {
    case true:
      return { status: 200, data: mockData.getLandBy };
    default:
      return instance.get(
        `/PersonalInfo/GetISTDClearance?NationalID=${NationalID}`,
      );
  }
};

export const getUserInfo = async (
  nationalId,
  cardNo,
  noCard = false,
  birthDate,
  ignoreExpiration = false,
) => {
  if (mock) {
    return { status: 200, data: mockData.getUserInfo };
  } else {
    if (birthDate) {
      return instance.get(
        `/PersonalInfo/GetPersonalInfoBy?NationalID=${nationalId}&BirthDate=${moment(
          birthDate,
        ).format("YYYY-MM-DD")}&ignoreExpiration=${ignoreExpiration}`,
      );
    } else if (noCard) {
      return instance.get(
        // `/PersonalInfo/GetPersonalInfoByNationalID?NationalID=${nationalId}&CardNo=${cardNo}`
        `/PersonalInfo/GetPersonalInfoBy?NationalID=${nationalId}&CardNo=${cardNo}&ignoreExpiration=${ignoreExpiration}`,
      );
    } else {
      return instance.get(
        `/PersonalInfo/GetPersonalInfoBy?NationalID=${nationalId}&CardNo=${cardNo}&ignoreExpiration=${ignoreExpiration}`,
      );
    }
  }
};

export const getApplicantInfo = async () => {
  if (mock) {
    return { status: 200, data: mockData.getApplicantInfo.citizen };
  } else {
    return instance.get(`/PersonalInfo/GetApplicantInfo`);
  }
};

export const getBuildType = async (BuildType) => {
  switch (mock) {
    case true:
      return { status: 200, data: mockData.getBuildTypes };
    default:
      return instance.get(`/Lookup/GetBuildType?BuildType=${BuildType}`);
  }
};

export const getRepresentationsBy = async (
  clientNationalId,
  repNationalId,
  applicationId,
  date,
) => {
  switch (mock) {
    case true:
      return { status: 200, data: mockData.getRepresentationsBy };
    default:
      return instance.get(
        `/BailsAndProcurations/GetRepresentationsBy?ClientNationalID=${clientNationalId}&RepresentativeNationalID=${repNationalId}&DocumentApplicationID=${applicationId}&DocumentDate=${date}`,
      );
  }
};
export const getNewRepresentationsBy = async (
  clientNationalId,
  repNationalId,
  applicationId,
  date,
  courtCode,
) => {
  switch (mock || process.env.REACT_APP_AGENCY === applicationId) {
    case true:
      return { status: 200, data: mockData.getRepresentationsBy };
    default:
      return instance.get(
        `/BailsAndProcurations/GetNewRepresentationsBy?ClientNationalID=${clientNationalId}&RepresentativeNationalID=${repNationalId}&DocumentSerial=${applicationId}&DocumentDate=${date}&CourtCode=${courtCode}`,
      );
  }
};

export const getAgencyFile = async (doc_Application_ID) => {
  switch (mock) {
    case true:
      return { status: 200, data: mockData.getRepresentationsBy };
    default:
      return instance.get(
        `/BailsAndProcurations/GetAgencyFile?DocID=${doc_Application_ID}`,
      );
  }
};

export const requestRealEstateLicense = async (data) => {
  switch (mock) {
    case true:
      return { status: 200, data: "success" };
    default:
      return instance.get(
        `/DLS/BailsAndProcurations/GetRepresentationsBy?ClientNationalID=${data.clientNationalId}&RepresentativeNationalID=${data.repNationalId}&DocumentApplicationID=${data.applicationId}&DocumentDate=${data.date}`,
      );
  }
};

export const deleteStop = async (data) => {
  return { status: 200, data: "تم إرسال الطلب بنجاح" };
};

export const getCompanyInfo = async (companyNatNo) => {
  switch (mock) {
    case true:
      return { status: 200, data: mockData.getCompanyInfo };
    default:
      return instance.get(
        `/LegalAffairs/GetCompanyProfile?companyNatNo=${companyNatNo}`,
      );
  }
};

export const getLegalInfo = async (
  nationalId,
  partyCode,
  demandType,
  demandNo = 0,
  demandYear = "",
  cardNo = "",
) => {
  demandNo = +demandNo;

  switch (mock) {
    // case true:
    //   return { status: 200, data: {} };
    case true:
      return { status: 200, data: mockData.getLegalDataWithStatus };
    default:
      return instance.get(
        `/LegalAffairs/GetLegalInfoByNationalID?NationalID=${nationalId}&PartyCode=${partyCode}&DemandType=${demandType}&DemandNo=${demandNo}&DemandYear=${demandYear}&CardNo=${cardNo}`,
      );
  }
};
export const getAllESTDataWithDemandType = async (
  demandType,
) => {
  switch (mock) {
    case true:
      return { status: 200, data: mockData.getLegalDataWithStatus };
    default:
      return instance.get(
        `/LegalAffairs/GetAllESTDataWithDemandType?demandType=${demandType}`,
      );
  }
};

export const checkDLSEmployee = async (nationalid) => {
  switch (mock) {
    case true:
      return { status: 400, data: {} };
    default:
      return instance.get(`/Lookup/GetDLSEmployeeBy?nationalid=${nationalid}`);
  }
};

export const getUserImage = async () => {
  switch (mock) {
    case true:
      return { status: 200, data: mock.personalImage };
    default:
      return instance.get("/Info/GetPersonalImage");
  }
};

export const getStudentInfo = async (nationalId) => {
  switch (mock || process.env.REACT_APP_ENV === "stg") {
    case true:
      return { status: 200, data: mockData.GetStudentInfo };
    default:
      return instance.get(`/Student/GetStudentInfo?NationalID=${nationalId}`, {
        hideToaster: true,
      });
  }
};

export const getNonCriminal = async (referanceNum, nationalId) => {
  switch (mock || referanceNum == process.env.REACT_APP_NON_CRIMINAL) {
    case true:
      return { status: 200, data: mockData.GetNonCriminalRecordCertificate };
    default:
      return instance.get(
        `/LegalAffairs/GetNonCriminalRecordCertificate?istrReferenceNumber=${referanceNum}&istrNationalNumber=${nationalId}`,
      );
  }
};

export const getSocialSecurityCert = async (nationalId) => {
  switch (mock) {
    case true:
      return { status: 200, data: mockData.socialSec };
    default:
      return instance.get(
        `/SocialSecurity/GetPersonStatus?NationalID=${nationalId}`,
      );
  }
};

export const getBuyerApproval = async (DecNo, nationalId) => {
  switch (mock) {
    case true:
      return { status: 200, data: mockData.getBuyerApproval };
    default:
      return instance.get(
        `Land/GetBuyerExemption?DecNo=${DecNo}&NationalID=${nationalId}`,
      );
  }
};

export const getMyInfo = async () => {
  switch (mock) {
    case true:
      return { status: 200, data: mockData.userInfo };
    default:
      return instance.get("/Info/GetPersonalInfo", {
        hideToaster: true,
      });
  }
};

export const getOpenRequest = async (regNo) => {
  switch (mock) {
    case true:
      return { status: 200, data: false };
    default:
      return instance.get(`/Land/GetOpenRequest?RegNo=${prepareParam(regNo)}`);
  }
};

export const getForignDetails = async (
  personalId,
  ignoreExpiration = false,
) => {
  switch (mock) {
    case true:
      return { status: 200, data: mockData.forigneData };
    default:
      return instance.get(
        `/PersonalInfo/GetForeignPersonalInfo?Id=${personalId}&ignoreExpiration=${ignoreExpiration}`,
      );
  }
};
export const getForeignPersonalInfo = async (personalId) => {
  switch (mock) {
    case true:
      return { status: 200, data: mockData.forigneData };
    default:
      return instance.get(`/Login/GetForeignPersonalInfo?Id=${personalId}`);
  }
};

export const getCommonEntity = async (id) => {
  switch (mock) {
    case true:
      return { status: 200, data: mockData.companyData };
    default:
      return instance.get(`/Login/GetCommonEntity?NATIONAL_NO=${id}`);
  }
};
export const getEntityAnonymousById = async (id) => {
  switch (mock) {
    case true:
      return { status: 200, data: mockData.companyData };
    default:
      // return instance.post(`/Login/GetEntityAnonymousById?NATIONAL_NO=${id}`);
      return instance.get(`/LegalAffairs/GetEntityAnonymousById?ID=${id}`);
  }
};
export const getESTDataV2 = async (id) => {
  switch (mock) {
    case true:
      return { status: 200, data: mockData.getESTDataV2 };
    default:
      return instance.get(`/LegalAffairs/GetESTDataV2?companyNatNo=${id}`);
  }
};

export const getESTData = async (id) => {
  switch (mock) {
    case true:
      return { status: 200, data: mockData.companyData };
    default:
      return instance.get(`/LegalAffairs/GetESTData?companyNatNo=${id}`);
  }
};

export const checkESTDataExist = async (
  demand_No,
  National_No,
  demand_Year,
) => {
  switch (mock) {
    case true:
      return { status: 200, data: mockData.companyData };
    default:
      return instance.get(
        `Login/CheckESTDataExist?demand_No=${demand_No}&com_National_No=${National_No}&demand_Year=${demand_Year}`,
      );
  }
};

export const getForeignApproval = async () => {
  return { status: 200, data: "موافق" };
};

export const isHodNeedClearance = async (
  VillCode,
  HodCode,
  SectCode,
  ParcNo,
) => {
  // export const isHodNeedClearance = async (villCode, hodCode) => {
  switch (mock) {
    case true:
      return { status: 200, data: true };
    default:
      return instance.get(
        `/Land/GetAgileExtAgreeParcMst?VillCode=${VillCode}&HodCode=${HodCode}&SectCode=${SectCode}&ParcNo=${ParcNo}`,
      );
    // return instance.get(
    //   `/Land/IsHodNeedSecurityClearance?VillCode=${villCode}&HodCode=${hodCode}`
    // );
  }
};

export const getIntityById = async (id) => {
  switch (mock) {
    case true:
      return {
        status: 200,
        data: {
          partyCode: "4",
          partyId: "4010178",
          partyName: "سلطة منطقة العقبة الاقتصاديه الخاصة",
        },
      };
    default:
      return instance.get(`/LegalAffairs/GetEntityById?ID=${id}`);
  }
};
export const getIndividualCompany = async (id) => {
  switch (mock) {
    case true:
      return {
        status: 200,
        data: {
          partyCode: "4",
          partyId: "4010178",
          partyName: "سلطة منطقة العقبة الاقتصاديه الخاصة",
        },
      };
    default:
      return instance.get(
        `/LegalAffairs/GetIndividualCompany?companyNatNo=${id}`,
      );
  }
};

export const getInvestmentApproval = async (regNo, partyId) => {
  switch (mock) {
    case true:
      return { status: 200, data: true };
    default:
      return instance.get(
        `/Land/GetInvestmentApproval?RegNo=${prepareParam(
          regNo,
        )}&PartyId=${partyId}`,
      );
  }
};

export const getRSOffice = async (nationalId, cardNo, demandNo, demandYear) => {
  switch (mock) {
    case true:
      return { status: 200, data: mockData.getRSOffice };
    default:
      return instance.get(
        `/LegalAffairs/GetRSOffice?NationalID=${nationalId}&CardNo=${cardNo}&DemandNo=${demandNo}&DemandYear=${demandYear}`,
      );
  }
};

export const getLandType = async (regNo, partyId) => {
  switch (mock) {
    case true:
      return { status: 200, data: mockData.GetLandType };
    default:
      return instance.get(
        `/Land/GetLandType?RegNo=${prepareParam(regNo)}&PartyId=${partyId}`,
      );
  }
};

export const getWellsDetails = async (DLSKey, dontUpdateLoading = false) => {
  switch (mock) {
    case true:
      return { status: 200, data: {} };
    default:
      return instance.get(`/Land/GetWellsDetails?DLSKey=${DLSKey}`, {
        dontUpdateLoading,
      });
  }
};
export const getDeptCodeByPRandom = async (pRandom) => {
  switch (mock) {
    case true:
      return { status: 200, data: "2" };
    default:
      return instance.get(`/Land/GetDeptCodeByPRandom?pRandom=${pRandom}`);
  }
};
export const getArgumentsTypes = async (MainArgumentID) => {
  return instance.get(
    `/Land/GetArgumentsTypes?MainArgumentID=${MainArgumentID}`,
  );
};
export const getArgumentsTypesQS = async (MainArgumentID) => {
  return instance.get(
    `/Land/GetArgumentsTypesQS?MainArgumentID=${MainArgumentID}`,
  );
};
export const getKinshipRelation = async (MinorNationalID, NationalID) => {
  switch (mock) {
    case true:
      return { status: 200, data: mockData.getKinshipRelation };
    default:
      return instance.get(
        `/PersonalInfo/KinshipRelation?MinorNationalID=${MinorNationalID}&NationalID=${NationalID}`,
      );
  }
};

export const getReligionByNationalID = async (NationalID) => {
  return instance.get(
    `/PersonalInfo/GetReligionByNationalID?NationalID=${NationalID}`,
  );
};
export const getReservLkp = async () => {
  return instance.get(`/Land/GetReservLkp`);
};

export const GetAgileExtAgreeParcMst = async (
  VillCode,
  HodCode,
  SectCode,
  ParcNo,
) => {
  switch (mock) {
    case true:
      return { status: 200, data: false };
    default:
      return instance.get(
        `/Land/GetAgileExtAgreeParcMst?VillCode=${VillCode}&HodCode=${HodCode}&SectCode=${SectCode}&ParcNo=${ParcNo}`,
      );
  }
};

export const CanPrintRegisteredPropertyReport = async (RegNo) => {
  return instance.get(
    `/Land/CanPrintRegisteredPropertyReport?RegNo=${prepareParam(RegNo)}`,
  );
};

export const GetLandRegNo = async (RegNo, dontUpdateLoading = false) => {
  switch (mock) {
    case true:
      return { status: 200, data: mockData.getLandBy };
    default:
      return instance.get(`/Land/GetLandRegNo?RegNo=${prepareParam(RegNo)}`, {
        dontUpdateLoading: dontUpdateLoading,
      });
  }
};

export const checkAgileIslamicBank = async (PartyId, PartyCode) => {
  if (mock) {
    return { status: 200, data: true };
  }

  return instance.get(
    `/Land/CheckAgileIslamicBank?PartyId=${PartyId}&PartyCode=${PartyCode}`,
    {
      hideToaster: true,
    },
  );
};

export const getMilitaryPersonData = async (NAT_NO, BIRTHDT, CIV_NO) => {
  switch (mock) {
    case true:
      return { status: 200, data: mockData.getUserInfo };
    default:
      return instance.get(
        // `/PersonalInfo/GetMilitaryPersonData?NAT_NO=9951043949&BIRTHDT=1995-09-02&CIV_NO=027/213`
        `/PersonalInfo/GetMilitaryPersonData?NAT_NO=${NAT_NO}&BIRTHDT=${BIRTHDT}&CIV_NO=${CIV_NO}`,
      );
  }
};
export const getPersonData = async (NAT_NO, BIRTHDT, CIV_NO) => {
  switch (mock) {
    case true:
      return { status: 200, data: mockData.GetLandType };
    default:
      return instance.get(
        `/Login/GetPersonData?NAT_NO=${NAT_NO}&BIRTHDT=${BIRTHDT}&CIV_NO=${CIV_NO}`,
      );
  }
};
export const doInvestmentServicesLog = async (serviceId) => {
  switch (mock) {
    case true:
      return { status: 200, data: "" };
    default:
      return instance.get(
        `/Land/DoInvestmentServicesLog?serviceId=${serviceId}`,
      );
  }
};

export const getCourts = async () => {
  switch (mock) {
    case true:
      return { status: 200, data: "" };
    default:
      return instance.get(`/BailsAndProcurations/GetCourts`);
  }
};

export const sendAccountOperationOTP = async (
  number,
  areaCode,
  countryCode,
) => {
  switch (mock) {
    case true:
      return { status: 200, data: mockData.companyData };
    default:
      return instance.post(`/Login/SendAccountOperationOTP`, {
        // UserMob: mobile,
        MOBILE_NO_CC: countryCode,
        MOBILE_NO_AC: areaCode,
        MOBILE_NO: number,
      });
  }
};

export const registerNewUser = async (data) => {
  switch (mock) {
    case true:
      return { status: 200, data: mockData.companyData };
    default:
      return instance.post(`/Login/RegisterNewUser`, data);
  }
};

export const getCOUNTLKP = async () => {
  switch (mock) {
    case true:
      return {
        status: 200,
        data: [
          {
            counT_CODE: "51",
            nationality: "الهندية",
            nationalitY_ENAME: "INDIAN",
          },
        ],
      };
    default:
      return instance.get(`/Lookup/GetCOUNTLKP`);
  }
};

export const getLoginUrl = async () => {
  switch (mock) {
    case true:
      return { status: 200, data: "https://www.google.com" };
    default:
      return instance.get(`/Login/GetLoginurl`);
  }
};

export const getSSOToken = async (code, state) => {
  switch (mock) {
    case true:
      return {
        status: 200,
        data: {
          access_token: "ynLupCB8jcLOGu92LLGhtQnjMuUgOomTtWTluTY9",
          refresh_token: "n8M68YTBOUYS2jsqzoQpznwuUjfGXon8u8HBl02M",
          scope: "openid",
          id_token:
            "eyJraWQiOiJseHBua21ucGxCQzdGUDlLOF9LSEJzSUZjTnZOMnQ4UFhkS0RDUTMxNTU0IiwiYWxnIjoiUlMyNTYifQ.eyJydF9oYXNoIjoiamNkbHczaGhFTmh2QzFlSTBfVjBRUSIsImlhdCI6MTc2MzkxNzIyMiwiaXNzIjoiaHR0cHM6Ly9zdGFnaW5nLmpvcmRhbi5nb3Yuam8iLCJhdF9oYXNoIjoiNkZWWWpvMVJCWnVrQUJ2UDVEVWUzQSIsInN1YiI6Ijk3NjEwNDE4NjIiLCJleHAiOjE3NjM5MTc5NDIsImF1ZCI6ImFsc2pYSU1oU0hmbUJ2OEg3QkpRIn0.KUbGypu9b30RL2ztDKjobnJZr12c4RX-4TFUBTNQueJCdijsuypXkwSlACYj_svZSiB_nChsou3KFC9hEmQMJ8mgNauSCen_ewYsQvmaBVuDTrbvURlrfspaUdxWT_xs_fYxZf805O-39KYs1MYYxQkSWact2gTJnT_haAENXHW2CQk3t-WmIly2e9hGxD7dsWvSvDGGDWWKR9JsWz7QsKbekokPk7P9zqQzMGykszr86rt-XFGJOKe75-htOAxHUwv6Upx164kSXsSx6kZ7O0mIE9iq0V0zqjxxPdcJ_tv3WjDa2T-6jKa9jWTmCm9DmNedqof37_zIw6c3J0ZU9A",
          token_type: "bearer",
          expires_in: "899",
          userFullNameAr: {
            arNAME1: "شكرى",
            arNAME2: "عوني",
            arNAME3: "شكرى",
            arNAME4: "دعاس",
          },
          userFullNameEn: {
            enNAME1: "SHUKRI",
            enNAME2: "AWNI",
            enNAME3: "SHUKRI",
            enNAME4: "DA'AS",
          },
          birthDate: "1976-12-24T00:00:00",
          nationality: "اردني",
          sex: null,
          token: null,
        },
      };
    default:
      return instance.get(`/Login/callback?code=${code}&state=${state}`);
  }
};
